import './TrackmanEvents.scss';

import Separator from 'components/Separator/Separator';
import useSetPageTitle from 'utilities/useSetPageTitle';
import { useServices } from 'index';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { OnDemandRecordings } from './OnDemandRecordings/OnDemandRecordings';
import { UpcomingEventsNew } from './UpcomingEvents/UpcomingEvents';

export const TrackmanEvents = () => {
  const { t } = useTranslation();
  useSetPageTitle({
    title: t('Events', { ns: 'trackmanEvents' }),
    subtitle: t('StayUpdatedAboutUpcomingEvents', { ns: 'trackmanEvents' }),
  });

  const trackmanEventsService = useServices().trackmanEventsService;
  const trackmanEventsList = useQuery({
    queryKey: ['trackmanEventsList'],
    queryFn: trackmanEventsService.getTrackmanEvents,
    refetchOnWindowFocus: false,
  });

  return (
    <div className='trackman-events-wrapper'>
      <UpcomingEventsNew />
      {trackmanEventsList.data?.length ? <Separator /> : null}
      <OnDemandRecordings />
    </div>
  );
};
